import { jsx } from 'react/jsx-runtime';
import * as React from 'react';
import { rgba } from 'polished';
import styled, { css } from 'styled-components';
import { px2rem } from '../../../../helpers/rem.mjs';
import { ShavedText } from '../../../../components/shavedText/index.mjs';
import { NativeEmojiSafeText } from '../../../texts/index.mjs';
import { ChipBase } from '../../index.mjs';
import { Svg18RemoveDark } from '@moim/icons';

var Content = styled.div.withConfig({
  displayName: "Content",
  componentId: "sc-wr8hxw-0"
})(["", ""], function (props) {
  if (props.maxWidth) {
    return "max-width: ".concat(px2rem(props.maxWidth));
  }
  switch (props.size) {
    case "medium":
      {
        return "max-width: ".concat(px2rem(140), ";");
      }
    case "small":
      {
        return "max-width: ".concat(px2rem(110), ";");
      }
  }
});
var DeleteButtonWrapper = styled.div.withConfig({
  displayName: "DeleteButtonWrapper",
  componentId: "sc-wr8hxw-1"
})(["margin-left:", ";display:flex;align-items:center;"], px2rem(4));
var PositionChip = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var id = _ref.id,
    size = _ref.size,
    color = _ref.color,
    name = _ref.name,
    showDeleteButton = _ref.showDeleteButton,
    maxContentWidth = _ref.maxContentWidth,
    propsOverrideStyle = _ref.overrideStyle,
    className = _ref.className,
    onClick = _ref.onClick,
    onDeleteClick = _ref.onDeleteClick;
  var refThis = React.useRef(null);
  React.useImperativeHandle(ref, function () {
    return refThis.current;
  });
  var handleDeleteClick = React.useCallback(function () {
    onDeleteClick === null || onDeleteClick === void 0 ? void 0 : onDeleteClick(id);
  }, [id, onDeleteClick]);
  var shavedTextWrapperStyle = React.useMemo(function () {
    return showDeleteButton ? css(["display:inline-flex;align-items:center;"]) : undefined;
  }, [showDeleteButton]);
  var overrideStyle = React.useMemo(function () {
    return css(["min-width:0;color:", ";background-color:", ";", ""], function (props) {
      return color ? color : props.theme.colorV2.colorSet.grey800;
    }, function (props) {
      return color ? rgba(color, 0.15) : props.theme.colorV2.colorSet.grey50;
    }, propsOverrideStyle);
  }, [color, propsOverrideStyle]);
  var deleteButton = React.useMemo(function () {
    return showDeleteButton ? jsx(DeleteButtonWrapper, {
      children: jsx(Svg18RemoveDark, {
        size: "xs",
        role: "button",
        onClick: handleDeleteClick
      })
    }) : null;
  }, [handleDeleteClick, showDeleteButton]);
  return jsx(ChipBase, {
    ref: refThis,
    "data-positionid": id,
    shape: "rectangle",
    size: size,
    overrideStyle: overrideStyle,
    className: className,
    onClick: onClick,
    children: jsx(Content, {
      size: size,
      maxWidth: maxContentWidth,
      children: jsx(ShavedText, {
        value: jsx(NativeEmojiSafeText, {
          value: name
        }),
        endFix: deleteButton,
        wrapperStyle: shavedTextWrapperStyle
      })
    })
  });
});

export { PositionChip as default };
